import { useSelector } from "react-redux";

export const useFullName = () => {
  const userInfo = useSelector((state) => state.user?.info);
  if (!userInfo) return false;
  return `${userInfo.firstName} ${userInfo.lastName}`;
};
